export default __webpack_public_path__ + "static/media/globe.205ad062.svg";